module.exports = __webpack_public_path__ + "img/al.al40be1a3.svg";